import { mapAtom } from '../map'

export function getMap() {
  return mapAtom.map
}
